module.exports = __webpack_public_path__ + "img/owl-teal.767d00ca.svg";